interface ToastProps {
  message: string;
  onClose: () => void;
}

export default function Toast({ message, onClose }: ToastProps) {
  if (!message) return null;

  return (
    <div className="fixed bottom-6 left-1/2 z-[60] w-[calc(100%-2rem)] max-w-sm -translate-x-1/2 md:left-auto md:right-8 md:translate-x-0">
      <div className="flex items-center gap-3 rounded-lg border border-background-300/60 bg-background-200/95 px-4 py-3 backdrop-blur-md animate-fade-up">
        <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-primary-500/20 text-primary-300">
          <i className="ri-moon-clear-line" />
        </span>
        <p className="flex-1 text-sm text-foreground-800">{message}</p>
        <button
          type="button"
          onClick={onClose}
          aria-label="关闭提示"
          className="flex h-7 w-7 shrink-0 cursor-pointer items-center justify-center rounded-md text-foreground-500 transition-colors hover:text-foreground-900"
        >
          <i className="ri-close-line" />
        </button>
      </div>
    </div>
  );
}